export default __webpack_public_path__ + "static/media/icon_articles_on.aa7d861a.svg";